import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Modal from './components/Modal.vue'
import store from './store'
import i18n from './plugins/locales/index'
import * as dateUtils from './utils/date'

Object.assign(Vue.prototype, dateUtils)

Vue.use(Element)
Vue.config.productionTip = false
Vue.component('Modal', Modal)
store.dispatch('auth/initAuth')

new Vue({
  i18n,
  router,
  store,  // 将 store 作为选项传入
  render: h => h(App)
}).$mount('#app')